module.exports = __webpack_public_path__ + "static/img/examination.03349a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/examination.png
// module id = zmLx
// module chunks = 1